import React, { memo } from 'react';
import ImageContentSlide from './ImageContentSlide';
import ItemsListSlide from './ItemsListSlide';

type Props = {
  isActive: boolean;
  slide: any;
  sliderBulletsComp: any;
  onNextClick: any;
  onPrevClick: any;
  appendImageContentSlide?: JSX.Element | React.ReactNode;
  sliderTitle?: string;
  sliderBottomNote?: string;
};

export enum AnimatedSlideTemplate {
  IMAGE_CONTENT = 'image-content',
  ITEMS_LIST = 'items-list',
}

const AnimatedSlide = ({
  slide,
  isActive,
  sliderBulletsComp,
  onNextClick,
  onPrevClick,
  appendImageContentSlide,
  sliderTitle,
  sliderBottomNote,
}: Props) => {
  const template = slide.template ?? AnimatedSlideTemplate.IMAGE_CONTENT;

  const video =
    typeof slide.video === 'object'
      ? slide.video
      : {
          desktop: slide.video,
          mobile: slide.videoMob,
        };

  if (template === AnimatedSlideTemplate.IMAGE_CONTENT)
    return (
      <ImageContentSlide
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        videoClassName={slide.videoClassName ?? ''}
        video={video}
        image={slide.image}
        title={slide.copy?.title ?? slide.title}
        description={slide.copy?.description ?? slide.description}
        tagline={slide.tagline ?? sliderTitle ?? slide.copy?.tagline}
        isActive={isActive}
        appendSlide={appendImageContentSlide}
        bottomNote={slide?.bottomNote ?? sliderBottomNote}>
        {sliderBulletsComp}
      </ImageContentSlide>
    );

  if (template === AnimatedSlideTemplate.ITEMS_LIST) {
    return (
      <ItemsListSlide
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        title={slide?.title}
        tagline={slide?.tagline ?? sliderTitle ?? slide.copy?.tagline}
        listItems={slide?.list ? slide.list.map((col) => col.attributes.items) : slide.listItems}
        bottomNote={slide?.bottomNote ?? sliderBottomNote}
        isActive={isActive}>
        {sliderBulletsComp}
      </ItemsListSlide>
    );
  }

  return null;
};

export default memo(AnimatedSlide);
